<template>
  <div class="noSelect">
    <h1 class="appHeader" :class="tabSizing">{{pageTitle}}</h1>
    <tabs @clicked="tabClicked">
      <tab name="Toe Angle">
        <PageToeDemo v-bind:toeContent="toeContent" />
        <ComponentAlignment v-bind:alignmentContent="alignmentContent" />
        <hr/>
        <ComponentPromise v-bind:valuePromiseContent="valuePromiseContent" />
      </tab>
      <tab name="Camber Angle">
        <PageCamber v-bind:camberContent="camberContent"/>
        <ComponentAlignment v-bind:alignmentContent="alignmentContent" />
        <hr/>
        <ComponentPromise v-bind:valuePromiseContent="valuePromiseContent" />
      </tab>
      <tab name="ADAS">
        <PageADAS v-bind:adasContent="adasContent"></PageADAS>
        <hr/>
      </tab>
    </tabs>
  </div>
</template>

<script>
import PageToeDemo from "./components/PageToeDemo.vue";
import PageCamber from "./components/PageCamber.vue";
import ComponentAlignment from "./components/ComponentAlignment.vue";
import ComponentPromise from "./components/ComponentPromise.vue";
import PageADAS from "./components/PageADAS.vue"
import { default as data} from "./store/index";

export default {
  name: 'App',
  components: {
    PageToeDemo,
    PageCamber,
    PageADAS,
    ComponentAlignment,
    ComponentPromise
  },
  data() {
    return data;
  },
  methods: {
    tabClicked (selectedTab) {
      this.pageTitle = selectedTab.tab.name === 'ADAS' ? 'Advanced Safety Systems Calibration': 'Understanding Alignment';
    }
  }
}
</script>

<style lang="scss">

  @import url("https://use.typekit.net/ecp5dzt.css");

  .smallerTab {
    font-size: 3.5rem;
  }

  .tireMask {
  z-index: 3;
  position: absolute;
  background: linear-gradient(
    to right,
    rgba(255, 0, 0, 0.3) 10%,
    rgba(255, 255, 0, 0.3) 30%,
    transparent 50%
  );

  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;

  &.camber {
    width: 12%;
    bottom: 14%;
    -webkit-mask-image: url('./assets/wear-camber/camberWearTire2.svg');
    mask-image: url('./assets/wear-camber/camberWearTire2.svg');
  }

  &.camber-wear-1 {
    -webkit-mask-image: url('./assets/wear-camber/camberWearTire2.svg');
    mask-image: url('./assets/wear-camber/camberWearTire2.svg');
  }

  &.camber-wear-2 {
    -webkit-mask-image: url('./assets/wear-camber/camberWearTire3.svg');
    mask-image: url('./assets/wear-camber/camberWearTire3.svg');
  }

  &.camber-wear-3 {
    -webkit-mask-image: url('./assets/wear-camber/camberWearTire4.svg');
    mask-image: url('./assets/wear-camber/camberWearTire4.svg');
  }

  &.toe {
    width: 63px;
    -webkit-mask-image: url('./assets/toeWearTireLeft.svg');
    mask-image: url('./assets/toeWearTireLeft.svg');
  }

  &.toe-left-front {
    left: 4%;
  }

  &.toe-left-front-right {
    left: 5.5%;
  }

  &.toe-right-front {
    right: 4%;
  }

  &.toe-right-front-right {
    right: 5.5%;
  }

  &.less {
    background: linear-gradient(
    to right,
    rgba(255, 255, 0, 0.3) 10%,
    rgba(255, 255, 0, 0.3) 30%,
    transparent 50%
  );
  }

  &.less-flipped {
    background: linear-gradient(
    to left,
    rgba(255, 255, 0, 0.3) 10%,
    rgba(255, 255, 0, 0.3) 30%,
    transparent 50%
  );
  }

  &.more {
    background: linear-gradient(
    to right,
    rgba(255, 255, 0, 0.3) 10%,
    rgba(255, 0, 0, 0.3) 30%,
    transparent 50%
  );
  }

  &.more-flipped {
    background: linear-gradient(
    to left,
    rgba(255, 255, 0, 0.3) 10%,
    rgba(255, 0, 0, 0.3) 30%,
    transparent 50%
  );
  }

  &.most {
    background: linear-gradient(
    to right,
    rgba(255, 0, 0, 0.3) 10%,
    rgba(255, 0, 0, 0.3) 30%,
    transparent 50%
  );
  }

  &.most-flipped {
    background: linear-gradient(
    to left,
    rgba(255, 0, 0, 0.3) 10%,
    rgba(255, 0, 0, 0.3) 30%,
    transparent 50%
  );
  }
  }

  .redText {color: #be161d !important; font-weight: 800 !important;};

  .noSelect {
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .noSelect:focus {
      outline: none !important;
  }

  .modal-content {
  position: absolute;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 30%;
  height: 30%;
  }

  .modal-container {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .navDemo {width: 100%;}

  .appHeader {
    margin-top: 15px;
    padding-bottom: 20px;
  }

  .car-leave-active {
    animation: wobble 5s ease;
    transition: all 5s ease;
  }

  @keyframes wobble {
    50% { transform: translateX(300px);}
    100% { transform: translateX(300px); }
  }

  .carproper-leave-active {
    animation: carproper 4s;
    transition: all 4s linear;
  }

  @keyframes carproper {
    50% { transform: translateX(200px); }
    100% { transform: translateX(200px); }
  }

  .slide-fade-enter-active {
    transition: all 0.3s ease-out;
  }

  .slide-fade-leave-active {
    transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .slide-fade-enter-from,
  .slide-fade-leave-to {
    transform: translateX(20px);
    opacity: 0;
  }

  .slide-fade-top-enter-active {
    transition: all 0.3s ease-out;
  }

  .slide-fade-top-leave-active {
    transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .slide-fade-top-enter-from,
  .slide-fade-top-leave-to {
    transform: translateY(20px);
    opacity: 0;
  }

  .popupHandler {
    min-width: 300px;
    min-height: 108px;
    cursor: pointer;
  }

  .lesschwab-popup {
    display: flex;
    gap: 20px;
    min-width: 300px;
    padding: 20px;
    border: 1px solid #BDC2C7;
    border-left: 5px #FDC203 solid;
    justify-content: space-between;
    box-shadow: 0px 0px 20px rgba(26, 34, 38, 0.2);
    cursor: pointer;

    p{max-width: 200px; margin-bottom: 0;}
  }

  .icon-close {
    background-image: url('./assets/ui/ui-close.svg');
    background-repeat: no-repeat;
    background-size: contain;
    height: 18px;
    width: 18px;
    cursor: pointer;
    display: inline-block;
  }

  .icon-information {
    background-image: url('./assets/ui/ui-information.svg');
    background-repeat: no-repeat;
    background-size: contain;
    height: 18px;
    width: 18px;
    cursor: pointer;
    display: inline-block;
  }

  .tabs-component-tabs {
    display: flex;
    border-bottom: 1px #DFE1E4 solid;
    gap: 40px;
    margin-left: auto;
    margin-right: auto;
    max-width: 60rem;
    padding-left: 10px;
    padding-right: 10px;
  }

  .tabs-component-tab-a {
    font-family: proxima-nova,Helvetica,Roboto,Arial,sans-serif;
    padding: 20px 40px;
    display: block;

    @media(min-width: 992px) {
      padding: 20px 80px;
    }
  }

  .tabs-component-tab {
    font-family: 'Proxima Nova';
    font-style: normal;
    font-weight: 900;
    font-size: 20px;
    line-height: 24px;
    text-transform: uppercase;
    color: inherit;

    &.is-inactive {
      background-color: white;
      border-top: 5px white solid;
      border-left: 1px white solid;
      border-right: 1px white solid;
    }

    &.is-active {
      background-color: white;
      border-top: 5px #FDC203 solid;
      border-left: 1px #DFE1E4 solid;
      border-right: 1px #DFE1E4 solid;

      a {
        color: #1A2226 !important;
      }

      &:after{
      content:'';
      display:block;
      border-bottom: 3px solid white;
      transform: translateY(2px)
    }
    }
  }

  h1 {text-align: center;}

  .sliderButtons {
    width: 300px;
    height: 100px;

    &.camber {
      width: 230px;
      padding: 20px;
    }
  }

  .lesschwabSliderButton {
    position: relative;
  }

  .increaseScale {
    cursor: pointer;
    position: absolute;
    width: 150px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.left {
      top: 0;
      left: 0;
    }

    &.right {
      top: 0;
      right: 0;
    }
  }

  .plus {
      background-image: url('./assets/ui/ui-slider-add.svg');
      background-repeat: no-repeat;
      background-size: 20px;

    &.background-left {
      background-position: 30% 50%;
    }

    &.background-right {
      background-position: 70% 50%;
    }

    &:active {
      background-size: 25px;
      transition: 0.1s ease-in-out all;
    }
  }

  .minus {
    background-image: url('./assets/ui/ui-slider-minus.svg');
    background-repeat: no-repeat;
    background-size: 10px;

    &.background-left {
      background-position: 30% 50%;
    }

    &.background-right {
      background-position: 70% 50%;
    }

    &:active {
      background-size: 15px;
      transition: 0.1s ease-in-out all;
    }
  }

  .lesschwabSliderContainer {
    cursor: pointer;
    position: relative;
    width: 300px;
    height: 100px;
    margin-top: 20px;
    cursor: pointer;

    &.minislider {
      width: 250px;
    }

    &.largerslider {
      margin-top: 0;
    }

    &.camber {
      width: 230px;
    }
  }

  .slider {
    position: absolute;
    width: 100%;
    height: 100px;
    z-index: 3;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }


  .slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 6px;
    height: 100px;
    background: transparent;
    cursor: pointer;
  }

  input[type=range] {
    -webkit-appearance: none;
    background-color: transparent;
    border: none;
  }

  input[type=range]:focus {
    outline: none;
  }

  input[type=range]::-webkit-slider-runnable-track {
    width: 100%;
    height: 10px;
    cursor: pointer;
    background: none;
    border: transparent;
    border: none;
  }

  input[type=range]::-webkit-slider-thumb {
    background-image: url('./assets/ui/ui-arrow.svg');
    background-repeat: no-repeat;
    background-size: contain;
    height: 80px;
    width: 50px;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -35px;
    transform: translateX(-2px);
    border: none;
  }

  input[type=range]:active::-webkit-slider-thumb {
    scale: 1.1;
  }

  input[type=range]:focus::-webkit-slider-runnable-track {
    background: none;
  }

  input[type=range]::-moz-range-track {
    width: 100%;
    height: 10px;
    cursor: pointer;
    background: none;
    border-radius: 5px;
  }

  input[type=range]::-moz-range-thumb {
    background-image: url('./assets/ui/ui-arrow.svg');
    background-repeat: no-repeat;
    background-size: contain;
    background-color: transparent;
    box-shadow: none;
    height: 80px;
    width: 50px;
    cursor: pointer;
    -moz-appearance: none;
    border: none;
    transform: translateX(-2px);
  }

  input[type=range]:active::-moz-range-thumb {
    scale: 1.1;
  }

  input[type=range]::-ms-track {
    width: 100%;
    height: 10px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
  }

  input[type=range]::-ms-fill-lower {
    background: none;
    border: 1px solid #000000;
    border-radius: 10px;
    box-shadow: 1px 1px 1px #000000;
  }

  input[type=range]::-ms-fill-upper {
    background: none;
    border: 1px solid #000000;
    border-radius: 10px;
    box-shadow: 1px 1px 1px #000000;
  }

  input[type=range]::-ms-thumb {
    margin-top: 1px;
    box-shadow: none;
    border: 1px solid #000000;
    height: 30px;
    width: 15px;
    border-radius: 5px;
    background: transparent;
    margin-top: -35px;
    cursor: pointer;
    transform: translateX(-2px);
  }

  input[type=range]:active::-ms-thumb {
    scale: 1.1;
  }

  input[type=range]:focus::-ms-fill-lower {
    background: none;
  }

  input[type=range]:focus::-ms-fill-upper {
    background: none;
  }

</style>
